export interface HeaderProps {}

export const useHeader = (props: HeaderProps) => {
  return {
    ...props,
  }
}
